import React, { memo, useCallback, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import { ArrowIcon } from '@sharedCR/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconDirection, IconSize } from 'constants/coreDesignSystem';

import { BOTTOM_NAV_ICON_SIZE } from '../../../../BottomNav.constants';
import {
  getOptionIconWrapperStyles,
  optionButtonStyles,
  optionChevronStyles,
  optionTextStyles,
} from '../../CreateSheet.styles';

const ObjectOptionRow = memo(({ option, onSelect }) => {
  const Icon = option.icon;

  const onPress = useCallback(() => onSelect(option.id), [option.id, onSelect]);
  const iconWrapperStyles = useMemo(
    () => getOptionIconWrapperStyles(option.iconColor),
    [option.iconColor],
  );

  return (
    <Box
      component="button"
      data-testid={`create-sheet-option-${option.id}`}
      sx={optionButtonStyles}
      onClick={onPress}
    >
      <Box sx={iconWrapperStyles}>
        <Icon size={BOTTOM_NAV_ICON_SIZE} />
      </Box>
      <Box sx={optionTextStyles}>
        <Typography color="text.primary" variant="medium16">
          {option.title}
        </Typography>
        <Typography color="text.secondary" variant="regular12">
          {option.subtitle}
        </Typography>
      </Box>
      <Box sx={optionChevronStyles}>
        <ArrowIcon direction={IconDirection.RIGHT} size={IconSize[20]} />
      </Box>
    </Box>
  );
});

ObjectOptionRow.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    icon: PropTypes.elementType,
    iconColor: PropTypes.string,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ObjectOptionRow;
